'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadTimezones = exports.getTimezones = undefined;

var _factory = require('./factory');

var _makeDynamicDataLoade = (0, _factory.makeDynamicDataLoader)('timezones', function (set, client) {
  return client.venues.getVenueTimezones().then(function (data) {
    return set(data.timezones);
  });
}),
    getTimezones = _makeDynamicDataLoade.get,
    loadTimezones = _makeDynamicDataLoade.load;

exports.getTimezones = getTimezones;
exports.loadTimezones = loadTimezones;